<cmps-dialog
    class="cmps-event-centre-c-pop-base-v1--dialog cmps-cdk-border-width-0p cmps-cdk-p-0"
    [class.cmps-event-centre-c-pop-dialog--multiple]="_data?.multiple"
    [style.background-image]="
        'url(' + _data?.mapItem?.tpl?.backgroundImage + ')'
    "
>
    <cmps-dialog-header
        class="cmps-cdk-pt-0dot5 cmps-cdk-px-1"
        [closeTooltip]="_i18n._763_CLOSE | translate"
    ></cmps-dialog-header>
    <cmps-dialog-body>
        <div
            class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-align-items-center cmps-cdk-px-1"
        >
            <div class="cmps-event-centre-c-pop-base-v1--title-image">
                <img
                    class="w-100"
                    [src]="_data?.mapItem?.tpl?.titleImage"
                    alt=""
                />
            </div>
            <div class="cmps-cdk-mt-0dot5">
                <div
                    class="cmps-event-centre-c-pop-base-v1--title cmps-cdk-color-blue-100 cmps-cdk-font-bold"
                >
                    {{ _data?.mapItem?.tpl?.title }}
                </div>
            </div>
            <div class="cmps-cdk-mt-1">
                <div class="cmps-event-centre-c-pop-base-v1--message">
                    {{ _data?.mapItem?.tpl?.subTitle }}
                </div>
            </div>
            <div
                class="cmps-cdk-mt-1"
                #containerRef
            >
                <ng-container #ref></ng-container>
            </div>
        </div>
        <cmps-event-centre-c-pop-footer></cmps-event-centre-c-pop-footer>
    </cmps-dialog-body>
</cmps-dialog>
